import { createContext } from 'react';

export default createContext({
  notifications: [],
  notificationsStatus: 'loading',
});
